import moment from 'moment';
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import utils from '../../utils';
import { FaMapMarkedAlt } from 'react-icons/fa';
import LocationModal from '../../components/orders/LocationModal';
import DeliveryCodeModal from './DeliveryModal';
import paymentsService from '../../services/PaymentServices';
import toast from 'react-hot-toast';

function PaymentInfo({ payment, updatePage }) {
    const location = useLocation();
    const isTrackingPage = location.pathname.includes('/usr/track/');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [hasConfirmedAccess, setHasConfirmedAccess] = useState(false);
    const [accessCodeInput, setAccessCodeInput] = useState('');
    const [accessError, setAccessError] = useState('');
    const [error, setError] = useState()

    const handleAccessSubmit = (e) => {
        setAccessError()
        e.preventDefault();
        if ((accessCodeInput.length < 6) || accessCodeInput.length > 6) {
            toast.error(utils.toastError)
            setAccessError('Please 6 input values')
            return
        }

        if (parseInt(accessCodeInput) === payment.access_code) {
            setHasConfirmedAccess(true);
            setAccessError('');
        } else {
            setAccessError('Invalid access code. Please check with your admin.');
        }
    };

    const handleDeliveryConfirm = async (code) => {
        setError()
        setIsSubmitting(true);
        const data = {
            delivery_code: code,
            transaction_reference: payment?.transaction_reference
        }
        try {
            await paymentsService.confirmDelivery(data);
            updatePage?.(payment?.transaction_reference)
            toast.success("Delivery confirmed!");
            const closeBtn = document.getElementById("delivery-close-open-btn")
            closeBtn.click()
        } catch (err) {
            console.log(err);

            setError(err)
            toast.error(utils.toastError);
        } finally {
            setIsSubmitting(false);
        }
    };

    if (!isTrackingPage && !hasConfirmedAccess) {
        return (
            <div className="flex items-center justify-center">
                <div className="bg-white dark:bg-slate-900 p-6 md:p-8 border border-gray-200 dark:border-gray-700 rounded-lg shadow-lg">
                    <h2 className="text-xl font-bold text-center mb-4">Secure Delivery Access</h2>
                    <p className="text-gray-600 dark:text-gray-300 text-center mb-4">
                        Enter the <strong>access code</strong> provided by your admin to view this order.
                    </p>

                    <form onSubmit={handleAccessSubmit}>
                        <div className="form-control mb-3">
                            <label className="label">
                                <span className="label-text">Access Code: *</span>
                            </label>
                            <input
                                type="number"
                                inputMode="numeric"
                                value={accessCodeInput}
                                onChange={(e) => setAccessCodeInput(e.target.value)}
                                className="input input-bordered w-full"
                                placeholder="e.g. 123456"
                                required
                            />
                        </div>
                        {accessError && (
                            <p className="text-red-500 text-sm mb-3">{accessError}</p>
                        )}
                        <button
                            type="submit"
                            className="btn btn-primary w-full"
                            disabled={!accessCodeInput}
                        >
                            View Order
                        </button>
                    </form>
                </div>
            </div>
        );
    }

    return (
        <div className="">
            {(payment.cart?.delivery?.latitude && !isTrackingPage) && (
                <LocationModal
                    lat={payment.cart?.delivery?.latitude}
                    lng={payment.cart?.delivery?.longitude}
                />
            )}

            <div className="space-y-3">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-6">
                    <div className="border p-3 rounded-lg shadow-sm hover:shadow-md">
                        <p className="font-bold mb-1">Customer & Delivery</p>
                        <p><strong className='mr-2'>Customer:</strong> {payment?.customer_profile?.full_name || '—'}</p>
                        <p><strong className='mr-2'>Email:</strong> {payment?.customer_profile?.email || '—'}</p>
                        <p><strong className='mr-2'>Method:</strong> {payment?.payment_method || '—'}</p>
                        <p><strong className='mr-2'>Created:</strong> {moment(payment?.creation_time).format('lll')}</p>

                        {payment.cart?.delivery && (
                            <div className="mt-3 pt-2 border-t">
                                <div className="flex justify-between items-center gap-3 mb-1">
                                    <p><strong className=''>Delivery:</strong></p>
                                    {(
                                        payment.cart?.delivery?.latitude &&
                                        payment.cart?.delivery?.longitude &&
                                        !isTrackingPage
                                    ) && (
                                            <button
                                                onClick={() => {
                                                    document.getElementById('location-open-btn').click();
                                                }}
                                                className='btn btn-sm btn-neutral'
                                            >
                                                <FaMapMarkedAlt /> Map View
                                            </button>
                                        )}
                                </div>
                                <p><strong className='mr-2'>City:</strong> {payment.cart.delivery.city}</p>
                                <p><strong className='mr-2'>Street/Address:</strong> {payment.cart.delivery.street}</p>
                                {payment.cart.delivery.notes && (
                                    <>
                                        <p className='mr-2'><strong>Notes:</strong></p>
                                        <p className="text-gray-600">{payment.cart.delivery.notes}</p>
                                    </>
                                )}
                            </div>
                        )}
                    </div>
                    <div className="border p-3 rounded-lg shadow-sm hover:shadow-md">
                        <p className="font-bold mb-1">Status & Totals</p>
                        <div className="pb-2 border-b">
                            <p>
                                <strong className='mr-2'>Payment Status:</strong>{' '}
                                <span className={`px-2 py-1 rounded ${payment.status === 'Paid' ? 'bg-green-100 text-green-800' :
                                    payment.status === 'Failed' ? 'bg-red-100 text-red-800' :
                                        'bg-yellow-100 text-yellow-800'
                                    }`}>
                                    {payment.status}
                                </span>
                            </p>
                            <p>
                                <strong className='mr-2'>Delivery:</strong>{' '}
                                <span className={`px-2 py-1 rounded ${payment.delivery_status === 'Delivered' ? 'bg-green-100' :
                                    payment.delivery_status === 'Shipped' ? 'bg-blue-100' :
                                        'bg-gray-100'
                                    }`}>
                                    {payment.delivery_status}
                                </span>
                            </p>
                        </div>
                        <div className='pt-2'></div>
                        {payment?.mpesa_recept_number && (
                            <p><strong className='mr-2'>MPESA Receipt:</strong> {payment?.mpesa_recept_number}</p>
                        )}
                        <p ><strong className='mr-2'>Items Total:</strong> KES {parseFloat(payment.items_total || 0).toLocaleString()}</p>

                        <p><strong className='mr-2'>Delivery Total:</strong> KES {parseFloat(payment.delivery_total || 0).toLocaleString()}</p>
                        <p className="font-bold text-primary">
                            <strong className='mr-2'>Sum Total:</strong> KES {parseFloat(payment.total || 0).toLocaleString()}
                        </p>
                    </div>
                </div>

                <div className="mb-6">
                    <h3 className="font-bold text-lg mb-3">Ordered Items ({payment.get_cart_items?.length || 0})</h3>
                    {payment.get_cart_items && payment.get_cart_items.length > 0 ? (
                        <div className="space-y-3">
                            {payment.get_cart_items.map((item) => (
                                <div
                                    key={item.id}
                                    className="grid grid-cols-[auto_1fr_auto] gap-3 md:grid-cols-[auto_1fr_auto] items-start border p-3 rounded shadow-sm hover:shadow-md"
                                >
                                    <div className="shrink-0 flex gap-3 items-center">
                                        <Link to={`/product/${item.product?.slug}`} className="shrink-0">
                                            <img
                                                src={utils.baseUrl + item.product.image}
                                                alt={item.product.name}
                                                className="w-16 h-16 object-cover rounded"
                                            />
                                        </Link>
                                        <div>
                                            {item.product.store_name && (
                                                <p><strong className="mr-2">Store:</strong> {item.product.store_name}</p>
                                            )}
                                            {item.product.owner && (
                                                <p><strong className="mr-2">Owner:</strong> {'Admin'}</p>
                                            )}
                                        </div>
                                    </div>


                                    <div className="min-w-0">


                                        <p>
                                            <strong className="mr-2">Item Name:</strong>
                                            <span className="break-words">{item.product.name}</span>
                                        </p>

                                        {item.product.condition && (
                                            <p>
                                                <strong className="mr-2">Condition:</strong>
                                                <span>{item.product.condition}</span>
                                            </p>
                                        )}

                                        <p>
                                            Qty: {item.quantity} × KES {parseFloat(item.product.price).toLocaleString()} ={' '}
                                            <strong>KES {parseFloat(item.total).toLocaleString()}</strong>
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <p className="text-gray-500 italic">No items found.</p>
                    )}
                </div>

                {(!isTrackingPage && hasConfirmedAccess) && (
                    <div>
                        <p className="font-bold mb-3 text-lg">Confirm Delivery</p>
                        <DeliveryCodeModal
                            payment={payment}
                            updateError={error}
                            isLoading={isSubmitting}
                            onConfirm={handleDeliveryConfirm} />
                        <button
                            className="btn btn-secondary btn-wide"
                            onClick={() => {
                                if (payment?.delivery_status === 'Delivered') {
                                    toast.error("Item already delivered")
                                    return
                                }
                                document.getElementById('delivery-code-open-btn').click();
                            }}
                        >
                            Confirm Delivery
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}

export default PaymentInfo;